var _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.58,352.11h-93.4a7.16,7.16,0,0,1-7.24-8.05l20.15-200.79a9.13,9.13,0,0,1,8.86-8.05h93.4a7.18,7.18,0,0,1,7.25,8.05L340.44,344.06A9.13,9.13,0,0,1,331.58,352.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 388.78,
    width: 23.18,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.08,
    y: 80.06,
    width: 134.71,
    height: 118.26,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,75.46H72.36A1.34,1.34,0,0,0,71,76.8h0a1.34,1.34,0,0,0,1.33,1.33H230.23a1.34,1.34,0,0,0,1.34-1.33h0A1.34,1.34,0,0,0,230.23,75.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.75,
    y: 80.06,
    width: 137.76,
    height: 118.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.51,
    y: 78.31,
    width: 102.26,
    height: 121.75,
    transform: "translate(291.82 -13.44) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.87 190.32 149.89 88.06 172.06 88.06 158.04 190.32 135.87 190.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.81 190.32 176.82 88.06 185.47 88.06 171.45 190.32 162.81 190.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.87,
    y: 138.68,
    width: 102.26,
    height: 1.02,
    transform: "translate(352.19 -73.81) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.08,
    y: 73.07,
    width: 13.77,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.49,
    y: 73.07,
    width: 10.73,
    height: 191.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.85,
    y: 73.07,
    width: 13.77,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.26,
    y: 73.07,
    width: 10.73,
    height: 191.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.62,
    y: 73.07,
    width: 13.77,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.45,
    y: 73.07,
    width: 7.94,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.29,
    y: 73.07,
    width: 6.18,
    height: 191.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.38,
    y: 73.07,
    width: 7.94,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.23,
    y: 73.07,
    width: 6.18,
    height: 191.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.32,
    y: 73.07,
    width: 7.94,
    height: 191.93,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.99,
    y: 233.42,
    width: 225.62,
    height: 72.34,
    transform: "translate(672.39 -133.21) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.59,
    y: 163.44,
    width: 66.42,
    height: 64.4,
    transform: "translate(598.44 -207.16) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.59,
    y: 235.82,
    width: 66.42,
    height: 64.4,
    transform: "translate(670.82 -134.78) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.59,
    y: 308.2,
    width: 66.42,
    height: 64.4,
    transform: "translate(743.2 -62.4) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.13,
    y: 182.98,
    width: 66.42,
    height: 25.33,
    transform: "translate(617.98 -226.69) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.13,
    y: 255.36,
    width: 66.42,
    height: 25.33,
    transform: "translate(690.36 -154.31) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.79,
    y: 202.32,
    width: 17.55,
    height: 26.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 202.32,
    width: 7.41,
    height: 26.53,
    transform: "translate(808.18 431.17) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.55,
    y: 209.22,
    width: 22.54,
    height: 19.63,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.04,
    y: 209.22,
    width: 9.52,
    height: 19.63,
    transform: "translate(753.59 438.07) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.13,
    y: 327.73,
    width: 66.42,
    height: 25.33,
    transform: "translate(762.73 -81.94) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 259.77,
    width: 225.62,
    height: 19.64,
    transform: "translate(626.39 -87.22) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.95,
    y: 334.67,
    width: 47.84,
    height: 38.94,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.6,
    y: 334.67,
    width: 9.35,
    height: 38.94,
    transform: "translate(750.55 708.27) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.89,
    y: 270.33,
    width: 42.51,
    height: 30.9,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.6,
    y: 270.33,
    width: 6.29,
    height: 30.9,
    transform: "translate(747.49 571.56) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.87,
    y: 233.42,
    width: 225.62,
    height: 72.34,
    transform: "translate(596.27 -57.09) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.47,
    y: 163.44,
    width: 66.42,
    height: 64.4,
    transform: "translate(522.33 -131.04) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.47,
    y: 235.82,
    width: 66.42,
    height: 64.4,
    transform: "translate(594.7 -58.66) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.47,
    y: 308.2,
    width: 66.42,
    height: 64.4,
    transform: "translate(667.08 13.72) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.01,
    y: 182.98,
    width: 66.42,
    height: 25.33,
    transform: "translate(541.86 -150.57) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.01,
    y: 255.36,
    width: 66.42,
    height: 25.33,
    transform: "translate(614.24 -78.2) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.66,
    y: 281.95,
    width: 17.55,
    height: 19.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.26,
    y: 281.95,
    width: 7.41,
    height: 19.28,
    transform: "translate(601.92 583.18) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 262.67,
    width: 17.55,
    height: 19.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.13,
    y: 262.67,
    width: 7.41,
    height: 19.28,
    transform: "translate(633.66 544.61) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.01,
    y: 281.95,
    width: 17.55,
    height: 19.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.6,
    y: 281.95,
    width: 7.41,
    height: 19.28,
    transform: "translate(658.61 583.18) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.01,
    y: 327.73,
    width: 66.42,
    height: 25.33,
    transform: "translate(686.61 -5.82) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.88,
    y: 259.77,
    width: 225.62,
    height: 19.64,
    transform: "translate(550.28 -11.1) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.22,
    y: 320.88,
    width: 39.57,
    height: 52.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.48,
    y: 320.88,
    width: 7.74,
    height: 52.73,
    transform: "translate(596.7 694.48) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.22,
    y: 187,
    width: 52.29,
    height: 41.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.48,
    y: 187,
    width: 7.74,
    height: 41.85,
    transform: "translate(596.7 415.85) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.91,
    cy: 130,
    r: 9.37,
    transform: "translate(126.72 422.79) rotate(-75.8)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.39,
    cy: 129.11,
    r: 9.37,
    transform: "translate(-1.74 4.8) rotate(-0.78)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.01,
    cy: 124.04,
    r: 9.37,
    transform: "translate(-4.44 13.71) rotate(-2.17)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.07,
    cy: 131.84,
    r: 9.37,
    transform: "translate(-4.72 14.21) rotate(-2.17)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.42,
    cy: 130,
    r: 9.37,
    transform: "translate(-13 211.91) rotate(-30.26)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,130.75s-1.09,26-42.91,26-42.91-26-42.91-26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.03,
    y: 275.65,
    width: 11.56,
    height: 100.27,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.47,
    y: 375.92,
    width: 177,
    height: 6.35,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.59,
    y: 275.65,
    width: 174.32,
    height: 100.27,
    transform: "translate(319.49 651.57) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.68,
    y: 287.99,
    width: 156.14,
    height: 32.88,
    rx: 7.12,
    transform: "translate(319.49 608.87) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.68,
    y: 330.69,
    width: 156.14,
    height: 32.88,
    rx: 7.12,
    transform: "translate(319.49 694.27) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.18,306.69H113.32a2.26,2.26,0,0,1-2.26-2.25h0a2.27,2.27,0,0,1,2.26-2.26h92.86a2.26,2.26,0,0,1,2.25,2.26h0A2.25,2.25,0,0,1,206.18,306.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.18,349.39H113.32a2.26,2.26,0,0,1-2.26-2.25h0a2.27,2.27,0,0,1,2.26-2.26h92.86a2.26,2.26,0,0,1,2.25,2.26h0A2.25,2.25,0,0,1,206.18,349.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.99,
    y: 235.76,
    width: 16.91,
    height: 39.89,
    transform: "translate(348.89 511.41) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.9,
    y: 235.76,
    width: 10.43,
    height: 39.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.57 230.56 165.99 230.56 173 275.65 153.57 275.65 146.57 230.56",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.39 230.56 165.99 230.56 173 275.65 181.4 275.65 174.39 230.56",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.69,
    y: 234.46,
    width: 18.78,
    height: 41.2,
    transform: "translate(294.16 510.11) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.47,
    y: 234.46,
    width: 9.52,
    height: 41.2,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.24,
    y: 241.12,
    width: 13.59,
    height: 34.53,
    transform: "translate(276.07 516.78) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.83,
    y: 241.12,
    width: 9.52,
    height: 34.53,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-64",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Navigation--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.81,355.89H237.25a7.52,7.52,0,0,1-7.59-8.45l20.83-207.55a9.59,9.59,0,0,1,9.29-8.45h99.56a7.53,7.53,0,0,1,7.6,8.45L346.1,347.44A9.58,9.58,0,0,1,336.81,355.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.63,
    y: 358.39,
    width: 22.65,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.73,
    y: 358.39,
    width: 7.22,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,355.89H234.72a7.52,7.52,0,0,1-7.59-8.45L248,139.89a9.59,9.59,0,0,1,9.29-8.45h99.56a7.53,7.53,0,0,1,7.6,8.45L343.57,347.44A9.59,9.59,0,0,1,334.28,355.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.58,352.11h-93.4a7.16,7.16,0,0,1-7.24-8.05l20.15-200.79a9.13,9.13,0,0,1,8.86-8.05h93.4a7.18,7.18,0,0,1,7.25,8.05L340.44,344.06A9.13,9.13,0,0,1,331.58,352.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-64)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187.27 290.52 183.18 288.49 288.01 105.95 292.1 107.98 187.27 290.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.4 296.78 202.5 294.44 319.64 118.64 323.55 120.98 206.4 296.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.42 335.7 215.46 333.44 353.2 118.3 357.16 120.56 219.42 335.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.26 371.05 277.53 370.9 299.74 203.26 304.77 201.17 282.26 371.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.39 402.37 258.44 400.11 396.18 184.96 400.14 187.22 262.39 402.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231 136.07 233.91 132.02 429.09 260.41 426.19 264.45 231 136.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.28 111.43 238.12 110.17 438.96 230.38 438.13 231.63 237.28 111.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.32 201.82 268.51 200.03 293.53 215 292.34 216.79 267.32 201.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.15 251.62 298.35 249.83 341.55 275.68 340.35 277.48 297.15 251.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.36 320.96 225.55 319.16 283.1 353.6 281.91 355.4 224.36 320.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.94 175.83 252.72 174.61 268.28 199.16 266.5 200.38 250.94 175.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.41 80.11 263.37 78.94 446.57 222.87 445.61 224.03 262.41 80.11",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,304.81a20.37,20.37,0,0,1-19.81,18,16,16,0,0,1-16.19-18c1.82-18.12,20.83-28.23,20.83-28.23S309.45,286.69,307.63,304.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.3,304.81a6.41,6.41,0,0,1-6.24,5.66,5,5,0,0,1-5.1-5.66,6.42,6.42,0,0,1,6.24-5.67A5,5,0,0,1,295.3,304.81Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.14,270.89h0a.9.9,0,0,1-.87-1l8.37-65.28a11.15,11.15,0,0,1,1.73-4.66l22.4-34.55a1,1,0,0,0-.25-1.36l-22.94-13.92a.94.94,0,0,1-.23-1.36,1.07,1.07,0,0,1,1.4-.38l22.93,13.92a2.86,2.86,0,0,1,.75,4.06L304,200.88a9.09,9.09,0,0,0-1.39,3.75l-8.36,65.29A1.14,1.14,0,0,1,293.14,270.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,124.4a16.39,16.39,0,0,1,15.95-14.5,12.89,12.89,0,0,1,13.05,14.5c-1.47,14.6-16.79,22.73-16.79,22.73S288.66,139,290.13,124.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,124.4a16.39,16.39,0,0,1,15.95-14.5,12.89,12.89,0,0,1,13.05,14.5c-1.47,14.6-16.79,22.73-16.79,22.73S288.66,139,290.13,124.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.63,
    cy: 124.4,
    rx: 9.61,
    ry: 8.69,
    transform: "translate(-1.84 244.19) rotate(-43.56)",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.24,180.61c-.31.83-.67,1.9-1,2.87s-.64,2-1,3c-.62,2-1.22,4.08-1.76,6.15s-1,4.16-1.52,6.25l-.68,3.15-.33,1.58-.07.37,0,.21c0,.12,0,.35,0,.52a28.41,28.41,0,0,0,.48,5.77c.32,2.06.75,4.16,1.21,6.27.95,4.21,2,8.49,3.08,12.71l-4,1.5a116.93,116.93,0,0,1-5.22-12.45c-.76-2.14-1.44-4.31-2-6.57-.29-1.12-.55-2.28-.77-3.48a22.74,22.74,0,0,1-.41-3.87,8.71,8.71,0,0,1,0-1.13l.05-.61.06-.45.21-1.69c.13-1.12.32-2.25.49-3.37.38-2.24.77-4.48,1.29-6.7s1-4.43,1.69-6.63c.33-1.1.67-2.19,1-3.29s.74-2.14,1.24-3.36Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,230.35l-1.4,5.93,3.71,4.39s4.94-14.32-.27-13.63Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,408.18a10.18,10.18,0,0,1-2.21-.3.2.2,0,0,1-.07-.36c.29-.19,2.82-1.83,3.79-1.39a.67.67,0,0,1,.4.56,1.12,1.12,0,0,1-.31,1.05A2.38,2.38,0,0,1,187.38,408.18Zm-1.65-.58c1.46.29,2.56.24,3-.15a.74.74,0,0,0,.19-.71.28.28,0,0,0-.17-.25C188.22,406.26,186.76,407,185.73,407.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.22,407.88l-.1,0a.19.19,0,0,1-.1-.17c0-.11,0-2.52.88-3.32a1,1,0,0,1,.84-.27.68.68,0,0,1,.67.55c.2,1-1.3,2.75-2.1,3.21A.15.15,0,0,1,185.22,407.88Zm1.39-3.39a.66.66,0,0,0-.44.17,4.51,4.51,0,0,0-.75,2.64c.79-.64,1.73-2,1.61-2.57,0-.09-.08-.21-.33-.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,164.15c.75-.05-.52-2.35-.87-2.53-.83-.43-9.74.84-9.31,2.22a4.68,4.68,0,0,0,1.21,2C179,166.16,180.92,164.42,187.5,164.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,169.6c-.25.71-2.12-1.13-2.2-1.53-.18-.91,3.46-9.14,4.67-8.35a4.68,4.68,0,0,1,1.61,1.71C185.71,162,183.52,163.35,181.47,169.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,148.07c1,5,3.17,15-.27,18.35,0,0,1.4,5,10.64,5,10.16,0,4.8-5,4.8-5-5.55-1.32-5.45-5.43-4.52-9.3Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76,168.41c-1.45.05.55-4.6,1.2-5,1.51-1,18.82-.19,18.26,2.53-.27,1.17-1.07,3.41-1.95,4.09S193.41,167.71,180.76,168.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47,137.41a.39.39,0,0,0,.32-.16,3.14,3.14,0,0,1,2.49-1.38.4.4,0,1,0,0-.79,3.89,3.89,0,0,0-3.18,1.7.39.39,0,0,0,.33.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,142.18a18,18,0,0,0,2.29,4.41,2.93,2.93,0,0,1-2.43.35Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,141c0,.68.33,1.24.77,1.25s.81-.51.83-1.19-.32-1.23-.76-1.25S205.18,140.33,205.16,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.8,139.84l1.64-.4S206.57,140.67,205.8,139.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.47 407.69 183.85 407.69 183 388.29 174.63 388.29 175.47 407.69",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,406.72h-9.41a.64.64,0,0,0-.66.57l-1,7.44a1.36,1.36,0,0,0,1.36,1.49c3.28-.05,4.86-.25,9-.25,2.54,0,6.26.27,9.78.27s3.67-3.48,2.2-3.79c-6.58-1.42-7.63-3.36-9.86-5.22A2.24,2.24,0,0,0,184.5,406.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.62 388.29 183 388.29 183.44 398.29 175.06 398.29 174.62 388.29"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,176.75c1.78,4.09,3.7,8.28,5.65,12.34a115.54,115.54,0,0,0,6.39,11.65,15.54,15.54,0,0,0,.88,1.3l.79,1.1a1.07,1.07,0,0,0,.63.48c.79.25,2.75-.24,4.51-1.11a55.69,55.69,0,0,0,10.71-7.4l3.14,2.84c-.74,1-1.49,1.93-2.28,2.85s-1.61,1.82-2.48,2.67a37.77,37.77,0,0,1-5.8,4.8,19.9,19.9,0,0,1-3.68,1.92A11.54,11.54,0,0,1,231,211a8.38,8.38,0,0,1-5.43-2.57c-.16-.16-.37-.39-.46-.5l-.31-.37-.61-.75c-.43-.5-.8-1-1.16-1.5a93.43,93.43,0,0,1-7.5-12.38c-2.19-4.23-4.16-8.45-6-12.9Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08,194.87,251,193l2.35,6.25s-5.86,2.05-8.65-.24l.15-1.07A3.94,3.94,0,0,1,247.08,194.87Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.86 192.88 257.57 197.49 253.38 199.22 251.03 192.97 256.86 192.88",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,137.79c.27,8.31.21,11.83,4.27,16.25,6.11,6.65,16.26,4.61,18.48-3.59,2-7.38,1.23-19.73-6.79-23.35A11.24,11.24,0,0,0,182.52,137.79Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,127.93c3.5-6.34,18.83-6.68,24,.4S202,135.22,200,142.18c.25,6.4,2.85,9.15,6.64,12.81-5.83,6.91-29.7,8-33.45,0S169.16,126.93,180.24,127.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.52,128.66s.56-2.59-2.67-2.35A10.72,10.72,0,0,1,180.52,128.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,141.64a7,7,0,0,0,1.95,4.17c1.49,1.53,3,.65,3.25-1.16.22-1.63-.29-4.39-2.1-5.26S198.36,139.79,198.5,141.64Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.26,219.12s-4.29,57.49-9,89.89c-3.81,26.17-6.42,87.35-6.42,87.35H173.39s-6-59.08-4.21-85c4.59-65.49-4.7-77.09,6-92.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,253.17a69,69,0,0,0,7.09,30.57c1.23-11.22,2.35-22.93,3.28-33.26C194,238.78,187.51,240.22,187.29,253.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.38 396.58 171.83 396.58 171.02 391.48 186.41 390.96 186.38 396.58",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,392.77a.2.2,0,0,1,0-.2.19.19,0,0,1,.19-.11c.43,0,4.16.36,4.75,1.38a.65.65,0,0,1,0,.62,1.07,1.07,0,0,1-.81.63c-1.2.21-3.08-1.35-4.1-2.29Zm4.55,1.22c-.39-.53-2.34-.92-3.82-1.08,1.42,1.24,2.64,1.91,3.31,1.79a.7.7,0,0,0,.53-.42.23.23,0,0,0,0-.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,392.77l0,0a.21.21,0,0,1,0-.2c.05-.07,1.4-1.88,2.75-2.06a1.44,1.44,0,0,1,1.12.29c.44.34.43.66.34.87-.36.88-3,1.37-4.08,1.22A.22.22,0,0,1,188.26,392.77Zm3.8-1.53a1.34,1.34,0,0,0-.17-.17,1.08,1.08,0,0,0-.82-.21,4.57,4.57,0,0,0-2.26,1.62c1.19,0,3.08-.47,3.29-1C192.12,391.44,192.15,391.36,192.06,391.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.64 389.34 187.36 392.66 190.64 385.52 194.91 376.18 195.41 375.09 187.69 371.76 187.13 372.98 182.98 382.03 179.64 389.34",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.98 382.03 190.64 385.52 194.91 376.18 187.13 372.98 182.98 382.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,219.12s13.09,57.14,13.38,86.55c.26,26.57-28.75,77.11-28.75,77.11L183.39,378s18.81-60.83,16.93-69.35c-5.43-24.72-14.6-78-14.62-89.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,391.54l-8-5a.66.66,0,0,0-.86.13l-4.81,5.74a1.36,1.36,0,0,0,.37,2c2.82,1.69,4.27,2.37,7.8,4.57,2.17,1.35,6.52,4.37,9.52,6.24s5-1,3.89-2c-4.86-4.68-6-7.7-7-10.45A2.17,2.17,0,0,0,188.46,391.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.64 384.92 181.13 379.37 182.57 373.92 197.03 379.84 194.64 384.92",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,177.71c.17-4.82-2.95-10.92-10.33-9.38-3.48.72-7.07,13.28-7.07,13.28l9.4,11C174.26,191.13,178.93,180.76,179,177.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.58,179A62.68,62.68,0,0,1,171,192.58l0,0c1.92-.89,4.34-4.92,6-8.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,168.57s4,1.4-3.5,50.55h-34c.43-13.84.37-22.38-6.53-50.8a99.75,99.75,0,0,1,14.43-1.9,107.4,107.4,0,0,1,15.44,0C205.21,167,212.75,168.57,212.75,168.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.52,185.39l-5.26.67c.33,4,2.9,8.76,5,11.29.43-3.66.75-6.85,1-9.63C212.85,186.28,212.52,185.39,212.52,185.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,168.57c4.18,1,9.41,12.44,9.41,12.44l-8.34,13.16s-10.6-7.92-10.5-19.37C203.37,170,207.69,167.34,212.75,168.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,217.13l-1.5,3c-.12.24.16.48.55.48h35.68c.31,0,.56-.15.58-.35l.27-3c0-.21-.24-.39-.58-.39H175.25A.6.6,0,0,0,174.7,217.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,217.13l-1.5,3c-.12.24.16.48.55.48h35.68c.31,0,.56-.15.58-.35l.27-3c0-.21-.24-.39-.58-.39H175.25A.6.6,0,0,0,174.7,217.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,221h-.92c-.18,0-.32-.1-.31-.21l.39-4c0-.12.17-.21.36-.21h.92c.18,0,.32.09.31.21l-.39,4C179.71,220.88,179.55,221,179.36,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,221h-.92c-.19,0-.33-.1-.32-.21l.4-4c0-.12.17-.21.35-.21h.92c.19,0,.33.09.32.21l-.4,4C202.07,220.88,201.91,221,201.73,221Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRafiki);
export default __webpack_public_path__ + "static/media/Navigation-rafiki.1c608ffcea6cba81a8b64fc944ed8083.svg";
export { ForwardRef as ReactComponent };